import React from 'react';
import { Button, Col, Form, Input, Modal, Row } from 'antd';

const OvercapacityModal = ({
  t,
  isOverCapacityModalVisible,
  handleCancel,
  currentBlock,
  overCapacityForm,
  submitOverCapacity,
  overCapacityLoading,
}) => {
  return (
    <Modal
      className="creation-modal"
      open={isOverCapacityModalVisible}
      onCancel={handleCancel}
      closable
      footer={false}
      width={500}
    >
      <Row className='pl-20 pr-20 pt-20 pb-20'>
        <Col lg={24} xs={24}>
          <Row justify='center'>
            <Col>
              <h1 className='text-center mb-20'>{t('reservations.overCapacityModal.title')}</h1>
              {currentBlock && <p className='mb-20'>{t('reservations.overCapacityModal.disclaimer1')} {currentBlock.block} hs. {t('reservations.overCapacityModal.disclaimer2')}.</p>}
            </Col>
            <Col lg={24} xs={24}>
              <Form form={overCapacityForm} size="large" className='cmt-form' onFinish={submitOverCapacity}>
                <Row gutter={[0, 20]}>
                  <Col lg={24} xs={24}>
                    <Form.Item name="code" rules={[{ required: true, message: 'Clave sobrecupo es requerida' }]}>
                      <Input className='cmt-input' placeholder='Ingrese clave sobrecupo' />
                    </Form.Item>
                  </Col>
                  <Col lg={24} xs={24}>
                    <Row gutter={[15, 15]} justify='center'>
                      <Col>
                        <Button className={overCapacityLoading ? 'cmt-button disabled outline' : 'cmt-button primary outline'} type='primary' size='large' onClick={handleCancel} disabled={overCapacityLoading}>
                          Cambiar bloque
                        </Button>
                      </Col>
                      <Col>
                        <Button className={overCapacityLoading ? 'cmt-button disabled' : 'cmt-button primary'} type='primary' size='large' htmlType='submit' loading={overCapacityLoading} disabled={overCapacityLoading}>
                          Autorizar sobrecupo
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
    </Modal>
  );
};

export default OvercapacityModal;
